import {createRoot} from 'react-dom/client';

import {EditRolloverData} from 'app/modules/aem/edit';
import {ComponentContextWrapper} from 'app/utils/initialize/components/componentContextWrapper';
import {GemInitializeComponents} from 'app/utils/initialize/components/gemInitializeComponents';

import {GemSettings} from '../config/interface';

export const initReinitializeListener = (gemSettings: GemSettings) => () => {
    const reinitialize = (data?: EditRolloverData) => {
        const rootElement = document.createElement('div');
        document.body.appendChild(rootElement);
        const root = createRoot(rootElement);

        if (data?.event === 'inline-edit-cancel') {
            data?.element?.querySelector('[data-content-ready]')?.removeAttribute('data-content-ready');
        }

        root.render(
            <ComponentContextWrapper gemSettings={gemSettings}>
                <GemInitializeComponents context={data?.element ?? document.body} />
            </ComponentContextWrapper>,
        );
    };

    if (gemSettings.wcmMode === 'EDIT') {
        import(/* webpackChunkName: "authorReinitialize" */ 'app/utils/initialize/authorReinitialize').then(({authorReinitialize}) =>
            authorReinitialize(reinitialize),
        );
    }

    // Used for test automation and in author edit
    document.addEventListener('gem.initialize', () => {
        console.log('gem.initialize');
        reinitialize();
    });
};
